import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import useTimeZones from 'components/Common/TimeZones/Hooks/useTimeZones';
import useCountries from 'components/Common/Countries/Hooks/useCountries';
import { useContext as useUsersContext } from 'components/Users/Context';
import StateField from 'components/Common/Affiliates/Form/StateField';
import Actions from 'components/Affiliates/Profile/Actions';

const transformValues = (values) => ({
  ...values,
  city_name: values.city,
  state_name: values.stateName,
  zip_code: values.zipCode,
  time_zone: values.timeZone,
});

export default function Basic({ onCloseClick }) {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const affiliate = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
    email: Yup.string().required('Email is required'),
    timeZone: Yup.string().typeError('Time Zone is required'),
    phone: Yup.string().required('Mobile Phone is required'),
    country: Yup.string().typeError('Country is required'),
    stateName: Yup.string().nullable().required('State is required'),
    city: Yup.string().required('City is required'),
    address: Yup.string().required('Address is required'),
    zipCode: Yup.string().required('Zip Code is required'),
  });

  const { timeZones } = useTimeZones();
  const { countries } = useCountries();

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      affiliate.id,
      transformValues(values),
      false,
      () => {
        setSubmitting(false);
        onCloseClick();
        actionsUsers.load(dispatchUsers);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        phone: affiliate.phone,
        email: stateUsers.user.attributes.email,
        country: affiliate.country,
        stateName: affiliate.state_name,
        city: affiliate.city_name,
        address: affiliate.address,
        address2: affiliate.address2,
        zipCode: affiliate.zip_code,
        timeZone: affiliate.time_zone,
      }}
      onSubmit={onSubmitHundler}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <Row>
            <Col>
              <HorizontalSelectField
                name="timeZone"
                label="Time Zone"
                placeholder={timeZones === null ? 'Loading...' : 'Select Time Zone'}
                options={timeZones === null ? [] : timeZones}
                required
              />
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <HorizontalTextField name="phone" label="Mobile Phone" required />
            </Col>

            <Col lg={6}>
              <HorizontalTextField name="email" type="email" label="Email" required />
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <HorizontalSelectField
                name="country"
                label="Country"
                placeholder={countries === null ? 'Loading...' : 'Select Country'}
                options={countries === null ? [] : countries}
                required
              />
            </Col>

            <Col lg={6}>
              <StateField />
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <HorizontalTextField name="city" label="City" required />
            </Col>

            <Col lg={6}>
              <HorizontalTextField name="zipCode" label="Zip Code" required />
            </Col>
          </Row>

          <Row>
            <Col>
              <HorizontalTextField as="textarea" name="address" label="Address 1" required />
            </Col>
          </Row>

          <Row>
            <Col>
              <HorizontalTextField as="textarea" name="address2" label="Address 2" />
            </Col>
          </Row>

          <Footer loading={isSubmitting} onCancel={() => onCloseClick()} />
        </FormikForm>
      )}
    </Formik>
  );
}

Basic.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
};
